const state = {
    step: ''
}

const getters ={
    step(state) {
        return state.step
    }
}

const mutations = {
    setStep(state, step) {
        state.step = step
    }
}

const actions = {
    clear({ commit }) {
        commit('setStep', '')
    },
    
    intendEntry({ commit }) {
        commit('setStep', 'entry')
    },

    intendConsents({ commit }) {
        commit('setStep', 'consents')
    },
    
    intendCoupon({ commit }) {
        commit('setStep', 'coupon')
    }
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}